import { Box, Grid, Table, TableBody, TableCell, TableRow } from "@material-ui/core";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";

import { DetailTable } from "../../../../components/detail_table";
import { IAsyncData } from "../../../../core/models";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { ProductHistoryDetail } from "../../../product_history/ui/components/product_history_detail";
import { SingleProductHistoryList } from "../../../product_history/ui/components/single_product_history_list";
import { SingleProductHistoryFilter } from "../../../product_history/ui/components/single_product_history_list_filter";
import { IProduct } from "../../data/entities";
import { productRedux } from "../state/state";

export const ProductDetailPage: React.FC = () => {
  const match = useRouteMatch<{ id: string }>();
  const { id } = match.params;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(productRedux.actions.getDetail(id));
  }, [dispatch, id]);
  const productDetailBranch = useSelector<IAppReduxState, IAsyncData<IProduct>>((state) => state.product.details);

  return (
    <Grid container justify="center" spacing={1}>
      <Grid item xs={12} lg={6}>
        <DetailTable branch={productDetailBranch} route={ROUTES.product}>
          <Table size="medium" className="detail-table">
            <TableBody>
              <TableRow>
                <TableCell>Ad</TableCell>
                <TableCell>{productDetailBranch.data?.name}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Qiymet</TableCell>
                <TableCell>{productDetailBranch.data?.price} AZN</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Çirkli çəki</TableCell>
                <TableCell>{productDetailBranch.data?.dirtyWeight} kq</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Təmiz çəki</TableCell>
                <TableCell>{productDetailBranch.data?.cleanWeight} kq</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Ümumi qiymət</TableCell>
                <TableCell>{productDetailBranch.data?.totalPrice} AZN</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>İtki faizi</TableCell>
                <TableCell>{productDetailBranch.data?.wastePercent} %</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </DetailTable>
      </Grid>

      <Grid item xs={12} lg={6}>
        <Box pt={7} />
        <SingleProductHistoryFilter productId={id} />
        <SingleProductHistoryList productId={id} />
      </Grid>

      <Grid item xs={12}>
        <ProductHistoryDetail productId={id} />
      </Grid>
    </Grid>
  );
};
